import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { A as Autoplay } from './embla-carousel-autoplay.esm-BukruCx2.js';

class HeroBanner extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType} */
  #embla;
  #autoplayDelay = parseInt(this.dataset.autoplay);
  #section = this.closest('.shopify-section--hero-banner');
  #slides = this.#section.querySelectorAll('.embla__slide');
  #height = this.#section.offsetHeight;

  connectedCallback() {
    this.#embla = EmblaCarousel(
      this.querySelector('.embla__viewport'),
      {
        loop: true,
        align: 'start',
        direction: document.dir,
        active: this.#slides.length > 1,
      },
      this.#autoplayDelay ? [Autoplay({ delay: this.#autoplayDelay })] : []
    );

    if (!this.hasAttribute('data-sticky-hero')) return;
    window.addEventListener('scroll', this.#onScroll, { passive: true });
    window.addEventListener('resize', this.#onResize, { passive: true });
    this.#onScroll();
    this.#embla.plugins().autoplay?.play();
  }

  disconnectedCallback() {
    this.#embla?.destroy();
    window.removeEventListener('scroll', this.#onScroll);
    window.removeEventListener('resize', this.#onResize);
  }

  #onResize = () => {
    this.#height = this.#section.offsetHeight;
  };

  #onScroll = () => {
    const clip = Math.max(0, Math.min(this.#height, window.scrollY));
    this.#section.style.setProperty('--clip-bottom', `${clip - 48}px`);
  };
}

customElements.define('hero-banner', HeroBanner);
